import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, RepartiTipo } from '../../models/-index';

@Injectable()
export class RepartiTipoService extends CrudGenericsService<RepartiTipo, number> {
  // private base:string;;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/RepartiTipo`);
    //  this.base = `${env.apiUrl}/api/RepartiTipo/`;
  }
}
